// threeInstance.js
import * as THREE from 'three';

const threeInstance = {
  color: new THREE.Color('#fff'),
};

export default threeInstance;
